import AxiosInitializer from 'api/Utility/AxiosInitializer'
import apiWrapper from 'api/Utility/ApiWrapper'
import { handleStatus500 } from 'api/Utility/HandleStatus500'
import AnonymousUserResponses from 'api/ResponseFormats/Common/AnonymousUser'

const axiosRequest = (extraParams: any = {}) => {
  const params = {
    ...extraParams,
  }

  return AxiosInitializer({
    ...params,
  })
}

const tokenEndPoint = {
  getAnonymousUserToken: (params = {}) => {
    return axiosRequest().get(`/token`, {
      params,
    })
  },
}

const anonymousUserAPI = {
  getAnonymousUserToken: (params = {}) =>
    apiWrapper({
      endPoint: tokenEndPoint.getAnonymousUserToken,
      params,
      errorFailureAction: handleStatus500,
      responseFormat: AnonymousUserResponses.StoreAnonymousToken,
    }),
}

export default anonymousUserAPI
